import { Component } from '@angular/core';
import { NavigationEnd,Event, Router, RouterOutlet } from '@angular/router';
import { AppStateService } from './shared/services/app-state.service';
import { LandingStateService } from './shared/services/landing-state.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'mamix';
  constructor(private appState : AppStateService,private router: Router,private landingState:LandingStateService){
    this.appState.updateState();
    this.landingState.updateState();

  }
  ngOnInit() {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        setTimeout(() => {
          // @ts-ignore
          HSStaticMethods.autoInit();
        }, 100);
      }
    });
  }

  }